
/* eslint-disable */
import verifyActivePromoCode from '@/mixins/verify_active_promo_code'
import { SwipeLeftMixin } from '@/mixins/swipe_mixin'

import configVars from "@/config/config_vars";
import microformatos from "@/api/microformatos";

let appFrontUrl = configVars.appFrontUrl;
let enableInvitation = configVars.enableInvitation;
import invitationsApi from "@/api/invitations";
import eventsApi from "@/api/events";
import seatMap from "@/api/tevo_seat_map";


import seatFormatMap from "@/api/seat_format/seat_format";
//import NoSSR from "vue-client-only";
let components = {
  //"client-only": NoSSR
};
import checkoutRoutes from "@/api/checkout.routes";

import { mapMutations, mapGetters } from "vuex";

import { JustDigits } from "@/util/filters";
import { setTimeout } from "timers";
import scroll from "@/util/scroll";
import fees from "@/api/fees";
JustDigits();

if (process.browser) {
  let VueSlider = require("vue-slider-component");
  components["vue-slider"] = VueSlider;
}

function generateSortFn(prop, reverse) {
  return function (a, b) {
    if (a[prop] < b[prop]) return reverse ? 1 : -1;
    if (a[prop] > b[prop]) return reverse ? -1 : 1;
    return 0;
  };
}

export default {
  async asyncData(context) {
    let search = context.params.search;
    let venue_date = context.params.venue_date;
    let event_id = context.params.event_id;
    let event = {};
    let structuredData = [];
    let breadCrumbList = [];

    if (!event_id) {
      //context.error({ statusCode: 404, message: 'Event id not provided' })
      context.redirect(`/book/${context.params.search}`);
      return
    }

    if (isNaN(event_id)) {
      context.redirect(`/book/${context.params.search}`);
      return
    }



    try {
      event = await eventsApi.searchEventById(event_id);
      event = event.data;
    } catch (error) {
      console.log(`Error Seat Page ${error}`);
    }
    if (!event || !event.id) {
      context.redirect(`/book/${context.params.search}`);
      return
    }


    let itemStructure = {
      "@context": "http://schema.org/",
      "@type": "Event",
      name: event.name,
      description: event.name,
      startDate: event.occurs_at,
      endDate: event.occurs_at,
      location: {
        "@type": "Place",
        name: event.venue.name,
        address: {
          streetAddress: event.venue.name,
          addressLocality: event.venue.location,
          addressRegion: "",
        },
      },
      performer: {
        "@type": "PerformingGroup",
        name: Array.isArray(event.performances) ? event.performances[0]?.performer.name : event.performances.performer.name,
      },
    };

    let performances = event.performances.map((item) => {
      return {
        url: `https://peppertix.org/book/${item.performer.slug}`,
        text: item.performer.name,
      };
    });

    breadCrumbList = microformatos.breadcrumbList(performances);

    structuredData.push(itemStructure);


    return {
      //img: event.configuration.seating_chart.medium,
      event,
      structuredData,
      breadCrumbList,
    };
    ///
  },
  head() {
    let content = `Tickets for ${this.event.name} event, on ${this.event.venue.location}, ${this.event.venue.name} at ${this.event.occurs_at_format}. Find your seat here.`;

    return {
      title: `${this.event.name} on ${this.event.venue.name}, ${this.event.venue.location} at ${this.event.occurs_at_format} | Pepper Tix`,
      meta: [
        {
          hid: "description",
          name: "description",
          content: content,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: content,
        },
        {
          property: "og:url",
          content: `${appFrontUrl}`,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:title",
          content: content,
        },
        {
          property: "og:image",
          content: `${appFrontUrl}img/pepper_tix_share_events.jpg`,
        },
      ],
      __dangerouslyDisableSanitizers: ["script"],
      script: [
        {
          innerHTML: JSON.stringify(this.structuredData),
          type: "application/ld+json",
        },
        {
          innerHTML: JSON.stringify(this.breadCrumbList),
          type: "application/ld+json",
        },
      ],
    };
  },
  mixins: [verifyActivePromoCode, SwipeLeftMixin],
  created() {
    this.$watch('user', this.activatePromoCode);
  },
  data() {
    return {
      isDestroyed: false,
      showSlide: false,
      factorFees: 0,
      promoCodeType: 'Introductory',
      factorFeesIncreased: 1,
      chatObject: null,
      noTicketsMessage: 'No tickets available',
      isMapAvailable: false,
      dialogMessage: {
        title: "",
        model: false,
        message: "",
      },
      toogleVip: false,
      one_signal_id: "",
      tevoMapsOptions: {},
      portraitStyleSeatLeft: "",
      portraitStyleSeatRight: "",
      promoCodeForApply: "",
      isUserVerified: false,

      showArrowRowFilter: null,
      showFilters: false,
      any_seat: true,
      structuredData: [],
      codigoMapa: "",
      errorimage: false,
      cargando: true,
      invitedFriends: [],
      enableInvitation: enableInvitation,
      hasActivatedInvitation: false,
      invitation: {},
      tickets_not_found: false,
      terms_of_service: configVars.terms_of_service,
      privacy_policy: configVars.privacy_policy,
      img: "",
      event: {},
      ticketGroups: [],
      value: 0,
      max: 0,
      min: 0,
      width_slider: 170,
      tickets: "N",
      seatmap: {},
      seatmapApi: null,
      sectionIds: [],
      selectBefore: "",
      ticketSelected: {},
      changeSingleTicket: false,
      ticketGroupsSection: [],
      isSelectionSearch: false,
      mouseHoverOrLeave: false,
      selectionsIds: [],
      tevo_section_name_before: "",
      tickets: "ANY",
    };
  },
  components: components,
  computed: {
    ...mapGetters({
      user: "user/user",
      isAutenticated: "user/isAutenticated",
      userIsVIPMember: "user/userIsVIPMember",
      media_match: "media_match",
      activePromoCode: "checkout/activePromoCode",
      isActivePromoBeenSetUp: "checkout/isActivePromoBeenSetUp",
      userHasPromoCode: "user/userHasPromoCode",
      showPromoToast: "showPromoToast",
      promoCodeFromUrl: "checkout/promoCodeFromUrl",
      quantity: "checkout/quantity",
      selectedTicketGroup: "checkout/selectedTicketGroup"
    }),

    ticketGroupsByPrice() {
      let result = this.ticketGroups;

      // Si `value` es 0, retornar un array vacío
      if (this.value === 0) {
        return [];
      }

      // Asegurarse de que `result` esté definido
      if (!result || !Array.isArray(result)) {
        return [];
      }

      // Función de filtro mejorada
      const filter = (ticketGroup) => {
        // Asegurarse de que `ticketGroup` y sus propiedades estén definidos
        if (!ticketGroup || typeof ticketGroup.retail_price === 'undefined' || !Array.isArray(ticketGroup.splits)) {
          return false;
        }

        if (ticketGroup.retail_price <= this.value + 1) {
          let retornar = false;

          if (isNaN(this.tickets)) {
            retornar = true;
          } else {
            retornar = ticketGroup.splits.includes(this.tickets);
          }

          // Si `value` es 0, retornar `false`
          if (this.value === 0) {
            retornar = false;
          }

          return retornar;
        }

        return false; // Retornar `false` si no se cumple la condición
      };

      return result.filter(filter);
    },


    ticketGroupsBySection: function () {
      let result = this.ticketGroupsSection;
      if (this.value == 0) {
        return [];
      }
      if (!result) return [];

      const filter = (ticketGroup) => {
        if (ticketGroup.retail_price <= this.value + 1) {
          let retornar = false;
          if (isNaN(this.tickets)) {
            retornar = true;
          } else {
            for (let i = 0; i < ticketGroup.splits.length; i++) {
              if (ticketGroup.splits[i] == this.tickets) {
                retornar = true;
              }
            }
          }
          if (this.value == 0) {
            retornar = false;
          }

          return retornar;
        }
      };

      return result.filter(filter);
    },

    goingFriends: function () {
      return this.invitedFriends.filter((friend) => {
        return friend.current_status == "Going";
      });
    },

    notGoingFriend: function () {
      return this.invitedFriends.filter((friend) => {
        return friend.current_status == "Not Going";
      });
    },

    pendingFriends: function () {
      return this.invitedFriends.filter((friend) => {
        return friend.current_status == "Pending";
      });
    },

    containerAllScreen: function () {
      if (this.userHasPromoCode == true) {
        return "container_all_screen overflow-hidden-desktop haspromo";
      } else {
        return "container_all_screen overflow-hidden-desktop";
      }
    },
    toogleVipComputed: {
      get() {
        return this.toogleVip;
      },
      set(newValue) {
        this.toogleVip = newValue;
      },
    },
  },

  async mounted() {
    this.cargando = true;
    this.errorimage = false;
    this.$nextTick(async () => {




      this.$store.commit("checkout/selectedTicketGroup", null)


      if (this.event) {
        if (this.event.venue) {
          if (this.event.venue.id) {
            if (this.event.configuration) {
              if (this.event.configuration.id) {
                try {
                  let response = await fetch(
                    `https://maps.ticketevolution.com/${this.event.venue.id}/${this.event.configuration.id}/map.svg`
                  );
                  if (response.status === 200) {
                    this.isMapAvailable = true;
                  } else {
                    this.isMapAvailable = false;
                  }
                } catch (error) {
                  this.isMapAvailable = false;
                }
              }
            }
          }
        }
      }

      seatMap.init_map();

      if (this.event != undefined) {
        this.page = 1;

        // turn element with ID of 'my-map' into a seatmap for config 1046
        try {
          this.tevoMapsOptions = {
            venueId: this.event.venue.id,
            configurationId: this.event.configuration.id,
            ticketGroups: this.ticketGroups,
            mouseControlEnabled: true,
            showLegend: true,
            showControls: true,
            mapsDomain: "https://maps.ticketevolution.com",
            onSelection: (sectionIds) => {
              this.sectionIds = sectionIds;

              this.OnSelectionIds(this.sectionIds);
            },
          };

          /*if (this.media_match === 0 || this.media_match === 1) {
            this.tevoMapsOptions.mouseControlEnabled = false;
            this.tevoMapsOptions.showLegend = false;
            this.tevoMapsOptions.showControls = false;
          }*/

          this.seatmap = new Tevomaps(this.tevoMapsOptions);

          try {
            this.seatmapApi = this.seatmap.build("my-map");
            //this.seatmapApi.mouseControlEnabled(false);
            //this.seatmapApi.showLegend(false);
            //this.seatmapApi.showControls(false);

            this.weHaveMap();
          } catch (e) { }
        } catch (e) { }

        if (this.event.id != undefined && this.event.id != null) {
          this.img = this.event.configuration.seating_chart.medium;

          let ticketGroups = await eventsApi.searchTicketGroups(this.event.id);
          console.log('ticketGroups')
          console.log(ticketGroups)
          if (ticketGroups.error) {
            this.noTicketsMessage = 'Request timeout'
          } else {
            this.noTicketsMessage = 'No tickets found'
          }


          this.ticketGroups = ticketGroups.data?.ticket_groups?.map(ticketGroup => ({
            ...ticketGroup,
            retail_price: ticketGroup.wholesale_price,
            formatDetail: seatFormatMap.seatFormatMap.get(ticketGroup.format).description
          })) || [];

          if (this.ticketGroups != undefined && this.ticketGroups.length > 0) {
            if (this.ticketGroups) {
              this.ticketGroups.sort(generateSortFn("retail_price", false));

              let indexInicial = 0;
              let indexFinal = this.ticketGroups.length - 1;

              this.max = Number(
                parseFloat(
                  this.ticketGroups[indexFinal].retail_price + 1
                ).toFixed(0)
              );

              this.value = Number(
                parseFloat(this.ticketGroups[indexFinal].retail_price).toFixed(
                  0
                )
              );

              this.min = Number(
                parseFloat(
                  Number(this.ticketGroups[indexInicial].retail_price)
                ).toFixed(0)
              );

              ///////////////////////////////////////////////////////////////////
              try {
                this.seatmapApi.updateTicketGroups(this.ticketGroups);
              } catch (e) {
                this.seatmap = new Tevomaps(this.tevoMapsOptions);

                try {
                  this.seatmapApi = this.seatmap.build("my-map");

                  this.weHaveMap();
                } catch (e) { }
              }

              /**
               *===================
               * Fees
               *===================
               */
              let factorFees = 0;
              let retail_price = this.ticketGroups[0].retail_price;
              let wholesale_price = this.ticketGroups[0].wholesale_price;
              factorFees = Number(
                parseFloat(
                  (retail_price - wholesale_price) / wholesale_price
                ).toFixed(2)
              );
              fees.createUpdateFees({ value: factorFees });
              /**
               *
               */
              this.factorFees = factorFees;
              this.factorFeesIncreased = 100 / (100 - factorFees * 100);
            }
          } else {
            this.tickets_not_found = true;
            this.ticketGroups = [];
          }
          this.cargando = false;
        }

        if (this.enableInvitation === true) {
          this.verifyInvitation();
        }
      }

      window.addEventListener("orientationchange", this.orientationChange);



      // perform some actions, like highlighting section "upper end zone 232"
      //seatmapApi.highlightSection("upper end zone 232");

      if (this.media_match === 0) {
        //primera screen and (max-width: 600px)

        this.showArrowRowFilter = true;
      } else if (this.media_match === 1) {
        //segunda screen and (min-width: 601px) and (max-width: 767px)

        this.showArrowRowFilter = true;
      } else if (this.media_match === 2) {
        //tercera screen and (min-width: 768px) and (max-width: 991px)

        this.showArrowRowFilter = false;
        this.showFilters = true;
      } else if (this.media_match === 3) {
        //cuarta screen and (min-width: 992px) and (max-width: 1199px)

        this.showArrowRowFilter = false;
        this.showFilters = true;
      } else if (this.media_match === 4) {
        //quinta screen and (min-width: 1200px)

        this.showArrowRowFilter = false;
        this.showFilters = true;
      }

      if (this.$OneSignal) {
        Promise.all([
          this.$OneSignal?.isPushNotificationsEnabled(),
          this.$OneSignal?.getUserId(),
          this.$OneSignal?.getRegistrationId(),
          this.$OneSignal?.getNotificationPermission(),
          this.$OneSignal?.isOptedOut(),
          //this.$OneSignal?.context.serviceWorkerManager.getActiveState()
        ])
          .then(
            ([
              isSubscribed,
              userId,
              registrationId,
              notificationPermission,
              optedOut,
              //serviceWorkerActive
            ]) => {
              this.$OneSignal?.setSubscription(true);
            }
          )
          .catch((e) => {
            console.error("Issue determining whether push is enabled:", e);
          });

        this.$OneSignal?.on(
          "notificationPermissionChange",
          (permissionChange) => {
            var currentPermission = permissionChange.to;
          }
        );

        this.$OneSignal?.on("subscriptionChange", (isSubscribed) => { });

        this.$OneSignal?.push(() => {
          this.$OneSignal?.getUserId(async (userId) => {
            this.one_signal_id = userId;
          });
        });
      }
    });
  },

  methods: {

    handleSwipeLeft() {//viene del mixin
      this.closeSelectedTicketGroup()
    },

    async onClickCheckOut() {

      this.$gtm.push({
        event: "productClick",
        ecommerce: {
          click: {
            actionField: { list: "Search Seats" }, // Optional list property.
            products: [
              {
                name: this.event.name, // Name or ID is required.
                id: this.event.id,
                price: parseFloat(this.selectedTicketGroup.retail_price).toFixed(2),
                brand: "peppertix-ticket-evo",
                category: this.selectedTicketGroup.format,
                variant: this.selectedTicketGroup.id,
                //position: index,
              },
            ],
          },
        },

      });


      let isThereBlokingOrders = await checkoutRoutes.isThereBlokingOrders(
        this.selectedTicketGroup.id,
      );
      let goNextStep = isThereBlokingOrders.data.goNextStep;



      if (goNextStep == true) {
        scroll.blockScroll(false);



        if ((this.activePromoCode && this.isActivePromoBeenSetUp) || (this.activePromoCode && this.userIsVIPMember)) {
          this.$router.push(`/checkout/${this.selectedTicketGroup.id}?quantity=${this.quantity}`)
          return
        }
        if (this.isAutenticated === true) {
          this.clickSendEmailPromo()

        } else {
          this.clickGetCodePromoRegister()
        }


        //this.$router.push(`/checkout/${this.selectedTicketGroup.id}?quantity=${this.quantity}`);
        //window.location.href =`/checkout/${ticket.id}?quantity=${quantity}`
      } else {
        this.dialogMessage.model = true;
        this.dialogMessage.title = "Ticket Group ";
        this.dialogMessage.message =
          "This ticket group is in other payment process";
      }

      if (window.fbq && this.selectedTicketGroup)
        window.fbq("trackCustom", "Seat-Click", {
          id: this.selectedTicketGroup?.id,
          price: parseFloat(this.selectedTicketGroup?.retail_price).toFixed(2),
        });

    },

    closeSelectedTicketGroup() {

      //this.selectedTicketGroup = null
      this.showSlide = false
      setTimeout(() => {
        this.$store.commit("checkout/selectedTicketGroup", null)
      }, 400)

    },

    handleScroll() {
      var position = document.getElementById('content_tickets').scrollTop;

    },

    clickSendEmailPromo() {
      this.$store.commit("signinform/signUpModePromo", true);
      this.$store.commit("signinform/toogleSignUp", true);
      this.$store.commit("toogleSignIn", true);
      this.$store.commit("showPromoToast", false);
    },


    clickGetCodePromoRegister() {
      this.$store.commit("signinform/signUpModePromo", false);
      this.$store.commit("signinform/toogleSignUp", true);
      this.$store.commit("toogleSignIn", true);
      this.$store.commit("showPromoToast", false);

      if (this.promoCodeFromUrl)
        this.$store.commit("signinform/signUpModePromo", true)
    },


    dialogClick() {
      this.dialogMessage.model = false;
    },

    orientationChange() {
      if (this.$device.isMobile) {
        if (window.matchMedia("(orientation: portrait)").matches) {
          this.portraitStyleSeatLeft = "margin-top: 0px!important;";
          //this.portraitStyleSeatRight = "height: 0px!important;";
        }

        if (window.matchMedia("(orientation: landscape)").matches) {
          this.portraitStyleSeatLeft = "";
          this.portraitStyleSeatRight = "";

          try {
            this.seatmap = new Tevomaps(this.tevoMapsOptions);
            this.seatmapApi = this.seatmap.build("my-map");

            this.weHaveMap();
          } catch (e) { }
        }
      }

      try {
        this.seatmap = new Tevomaps(this.tevoMapsOptions);
        this.seatmapApi.updateTicketGroups(this.ticketGroups);
        this.seatmapApi = this.seatmap.build("my-map");

        //this.weHaveMap();
      } catch (e) { }
    },
    weHaveMap() {
      let intervalo = setInterval(() => {
        let myMap = document.getElementById("my-map");
        let currentImageSrc = "-";
        if (myMap != undefined) {
          let arrayImages = myMap.getElementsByTagName("img");

          if (arrayImages[0]) {
            currentImageSrc = arrayImages[0].currentSrc;
          }
        }

        clearInterval(intervalo); //con esta funcion se detiene el temporizador
      }, 600);
    },
    clickShowFilters() {
      if (this.media_match <= 1) {
        this.showFilters = !this.showFilters;
      }
    },

    startHandler(event) {
      if (!event || this.isDestroyed) return
      try {
        const sectionId = event?.target?.parentElement?.id
        if (this.seatmapApi && sectionId) {
          this.seatmapApi.unhighlightSection(this.tevo_section_name_before);
          this.seatmapApi.highlightSection(sectionId);
          this.tevo_section_name_before = sectionId;
        }
      } catch (error) {
        console.error("startHandler error:", error)
      }
    },
    endHandler() { },
    touchHandler(touch) { },
    ticketClickHover(ticket) { },
    ticketClick(ticket) {
      //this.mouseHoverOrLeave = true;
      this.mouseHoverOrLeave == true;
      //this.seatmapApi.selectSection(ticket.tevo_section_name);
      if (this.seatmapApi != undefined) {
        this.seatmapApi.unhighlightSection(this.tevo_section_name_before);
        this.seatmapApi.highlightSection(ticket.tevo_section_name);

        this.tevo_section_name_before = ticket.tevo_section_name;
      }
    },
    mouseHoverTicket(ticket) {
      console.log('mouseHoverTicket')
      if (this.seatmapApi != undefined) {
        //this.mouseHoverOrLeave = true;
        this.mouseHoverOrLeave == true;
        //this.seatmapApi.selectSection(ticket.tevo_section_name);
        this.seatmapApi.unhighlightSection(this.tevo_section_name_before);
        this.seatmapApi.highlightSection(ticket.tevo_section_name);

        this.tevo_section_name_before = ticket.tevo_section_name;
      }
    },
    mouseLeaveTicket(ticket) {
      this.mouseHoverOrLeave = true;
    },
    backClick() {
      this.mouseHoverOrLeave = true;
      this.isSelectionSearch = false;

      this.seatmapApi.deselectSection(this.selectionsIds[0]);
    },
    OnSelectionIds(selectionsIds) {
      //this.selectedTicketGroup = null
      this.$store.commit("checkout/selectedTicketGroup", null)
      if (selectionsIds.length > 1) {

        this.seatmapApi.deselectSection(selectionsIds[0]);
      } else if (selectionsIds.length == 1) {
      } else if (selectionsIds.length == 0) {
      }

      this.selectionsIds = selectionsIds;

      let tevo_section_name = this.selectionsIds[0];

      if (tevo_section_name != undefined) {
        this.isSelectionSearch = true;
        this.ticketGroupsSection = [];
        for (let i = 0; i < this.ticketGroups.length; i++) {
          if (this.ticketGroups[i].tevo_section_name == tevo_section_name) {
            this.ticketGroupsSection.push(this.ticketGroups[i]);
          }
        }
        this.ticketGroupsSection.sort((a, b) => {
          const dateA = new Number(a.retail_price);
          const dateB = new Number(b.retail_price);
          return dateA - dateB;
        });
      } else {
        this.isSelectionSearch = false;
      }
    },

    searchOnKeyUp: function (event) {
      if (isNaN(event.key)) {
        this.tickets = "ANY";
        this.any_seat = true;
      } else {
        this.any_seat = false;
      }
    },
    imageStatus(current_status) {
      if (current_status == "Pending") {
        return "/img/invitations/invitees_pending.svg";
      } else if (current_status == "Going") {
        return "/img/invitations/invitees_going.svg";
      } else if (current_status == "Not Going") {
        return "/img/invitations/invitees_not_going.svg";
      }
    },
    verifyInvitation() {
      if (this.isAutenticated == true) {
        let params2 = {
          inviterId: this.user._id,
          eventId: this.$route.params.event_id,
        };

        invitationsApi.getInvitation(params2).then((invitationRes) => {
          if (invitationRes._id != undefined) {
            this.invitation = invitationRes;

            if (this.invitation.invitedFriends.length > 0) {
              this.hasActivatedInvitation = true;
              this.invitedFriends = this.invitation.invitedFriends;
            }
          }
          //this.performer =  ,
          /////invitationSelected: {},
        });
      } else {
      }
    },

    goBack() {
      //this.$router.push(`/book/${this.$route.params.search}`);
      window.history.back();
    },
    ClickBody() {
      this.$store.commit("ClickBody", true);
    },
    async toCheckout(ticket, index) {

      //this.selectedTicketGroup = ticket
      ticket.event = this.event

      this.$store.commit("checkout/selectedTicketGroup", ticket)


      return;

      let quantity = 0;
      if (!isNaN(this.tickets)) {
        quantity = this.tickets;
      }

      let category_name = "";
      if (this.event.category != undefined) {
        if (this.event.category.name != undefined) {
          category_name = this.event.category.name;
        }
      }
      this.$gtm.push({
        event: "productClick",
        ecommerce: {
          click: {
            actionField: { list: "Search Seats" }, // Optional list property.
            products: [
              {
                name: this.event.name, // Name or ID is required.
                id: this.event.id,
                price: parseFloat(ticket.retail_price).toFixed(2),
                brand: "peppertix-ticket-evo",
                category: ticket.format,
                variant: ticket.id,
                position: index,
              },
            ],
          },
        },
      });
      let isThereBlokingOrders = await checkoutRoutes.isThereBlokingOrders(
        ticket.id
      );
      let goNextStep = isThereBlokingOrders.data.goNextStep;



      if (goNextStep == true) {
        this.$router.push(`/checkout/${ticket.id}?quantity=${quantity}`);
        //window.location.href =`/checkout/${ticket.id}?quantity=${quantity}`
      } else {
        this.dialogMessage.model = true;
        this.dialogMessage.title = "Ticket Group ";
        this.dialogMessage.message =
          "This ticket group is in other payment process";
      }

      if (window.fbq)
        window.fbq("trackCustom", "Seat-Click", {
          id: ticket.id,
          price: parseFloat(ticket.retail_price).toFixed(2),
        });

      //
    },

    ticketMinus() {
      if (this.tickets - 1 >= 1) {
        this.tickets = Number(this.tickets) - 1;
        this.any_seat = false;
      } else {
        this.tickets = 1;
        this.tickets = "ANY";
        this.any_seat = true;
      }
    },
    ticketPlus() {
      if (!isNaN(this.tickets)) {
        if (Number(this.tickets) + 1 <= 20) {
          if (this.tickets == 0) {
            this.tickets = "ANY";
            this.any_seat = true;
          }
          if (this.tickets == "ANY") {
            this.tickets = 1;
          } else {
            this.tickets = Number(this.tickets) + 1;
            this.any_seat = false;
          }
        } else {
          this.tickets = 20;
          this.tickets = "ANY";
          this.any_seat = true;
        }
      } else {
        this.tickets = 1;
        this.any_seat = false;
      }
    },
    isNumber: function (e) {
      var keynum = window.event ? window.event.keyCode : e.which;
      if (keynum >= 49 && keynum <= 57) {
        this.any_seat = false;
        return true;
      } else {
        this.tickets = 1;

        this.tickets = "ANY";
        this.any_seat = true;
      }
    },

    filtrarPorRetailPrice(ticketGroup) {
      if (
        "retail_price" in ticketGroup &&
        typeof ticketGroup.retail_price === "number" &&
        !isNaN(ticketGroup.retail_price)
      ) {
        if (this.value <= ticketGroup.retail_price) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    errorInvitedImage(user) {
      user.imgSrc = "/img/home/profile.svg";
    },

    errorSeatImage() {
      this.img = "/img/seat/no_map_available.svg";
    },
  },
  watch: {

    selectedTicketGroup(val) {

      if (window.$chatwoot && this.media_match < 2) {
        if (val) {
          window.$chatwoot.toggleBubbleVisibility("hide");
        } else {
          window.$chatwoot.toggleBubbleVisibility("show");
        }
      }

      if (val != null) {
        setTimeout(() => {

          this.showSlide = !!val
        }, 0)
      }

      //scroll.blockScroll(!!val);
    },

    activePromoCode(val) {
      if (this.activePromoCode?.code === 'groupdiscount') {
        if (this.selectedTicketGroup) {
          //this.$router.push(`/checkout/${this.selectedTicketGroup.id}?quantity=${this.quantity}`)
        }

        this.$store.commit("checkout/isActivePromoBeenSetUp", true);
      }

    },

    showArrowRowFilter(val) {
      if (val == true) {
        //this.showFilters = true
      } else {
        //this.showFilters = false
      }
    },
    ticketGroupsByPrice(val) {
      if (val.length > 0) {
        this.tickets_not_found = false;
      } else {
        this.tickets_not_found = true;
      }
      try {
        if (this.seatmapApi) {
          this.seatmapApi.updateTicketGroups(this.ticketGroupsByPrice);
        }
      } catch (e) {
        if (Tevomaps != undefined) {
          this.seatmap = new Tevomaps(this.tevoMapsOptions);
          this.seatmapApi = this.seatmap.build("my-map");
          this.seatmapApi.updateTicketGroups(this.ticketGroupsByPrice);
        } else {
          let intervalo = setInterval(() => {
            if (Tevomaps != undefined) {
              this.seatmap = new Tevomaps(this.tevoMapsOptions);
              this.seatmapApi = this.seatmap.build("my-map");
              this.seatmapApi.updateTicketGroups(this.ticketGroupsByPrice);
              clearInterval(intervalo); //con esta funcion se detiene el temporizador
            }
          }, 200);
        }
      }
    },

    img(val) {
      if (val == "/img/seat/no_map_available.svg") {
        this.errorimage = true;
      } else {
        this.errorimage = false;
      }
    },
    media_match(newValue, oldValue) {
      if (this.chatObject) {
        this.chatObject.toggleBubbleVisibility("show")
        if (this.media_match < 2) {
          if (this.activePromoCode) {
            if (!this.userHasPromoCode) {
              this.chatObject.toggleBubbleVisibility("show")
            }
          }
        }
      }

      if (newValue === 0) {
        //primera screen and (max-width: 600px)
        this.showArrowRowFilter = true;
        this.width_slider = 170;
      } else if (newValue === 1) {
        //segunda screen and (min-width: 601px) and (max-width: 767px)
        this.showArrowRowFilter = true;
        this.width_slider = 170;
      } else if (newValue === 2) {
        //cuarta screen and (min-width: 992px) and (max-width: 1199px)
        this.showArrowRowFilter = false;
        this.showFilters = true;
        this.width_slider = 170;
      } else if (newValue === 3) {
        //quinta screen and (min-width: 1200px)
        this.showArrowRowFilter = false;
        this.showFilters = true;
        this.width_slider = 200;
      }
    },

    isAutenticated(newValue, oldValue) {
      if (newValue == true) {
        if (this.enableInvitation == true) {
          // this.verifyInvitation();
        }
      }
    },
  },
  beforeDestroy() {
    this.ticketGroups = []
    this.isDestroyed = true
    this.seatmapApi.updateTicketGroups(this.ticketGroups);
    const mapContainer = document.getElementById("my-map");
    if (mapContainer) {
      mapContainer.innerHTML = "";
    }
    this.seatmapApi = null
    window.removeEventListener("orientationchange", this.orientationChange);
    const tickets = document.querySelectorAll('.ticket');
    tickets.forEach(el => {
      console.log('delete handler')
      delete el._touchHandlers;
    });
  },
  destroyed: function () {

  },

};
